/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as ColorPickerDefault } from './color-picker-default.story';
export { default as ColorPickerWithoutEyeDropper } from './color-picker-without-eyedropper.story';
export { default as ColorPickerCustomSwatches } from './color-picker-custom-swatches.story';
export { default as ColorPickerDialog } from './color-picker-dialog.story';
export { default as ColorPickerPopover } from './color-picker-popover.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import ColorPickerCustomSwatchesSourceRaw from './color-picker-custom-swatches.story.tsx?raw';
import ColorPickerDefaultSourceRaw from './color-picker-default.story.tsx?raw';
import ColorPickerDialogSourceRaw from './color-picker-dialog.story.tsx?raw';
import ColorPickerPopoverSourceRaw from './color-picker-popover.story.tsx?raw';
import ColorPickerWithoutEyeDropperSourceRaw from './color-picker-without-eyedropper.story.tsx?raw';

export const ColorPickerDefaultSource = removeLicenseHeader(
  ColorPickerDefaultSourceRaw,
);
export const ColorPickerWithoutEyeDropperSource = removeLicenseHeader(
  ColorPickerWithoutEyeDropperSourceRaw,
);
export const ColorPickerCustomSwatchesSource = removeLicenseHeader(
  ColorPickerCustomSwatchesSourceRaw,
);
export const ColorPickerDialogSource = removeLicenseHeader(
  ColorPickerDialogSourceRaw,
);
export const ColorPickerPopoverSource = removeLicenseHeader(
  ColorPickerPopoverSourceRaw,
);
